const abi = `{
	"ABI version": 2,
	"header": ["time"],
	"functions": [
		{
			"name": "onGetSaleInfo",
			"inputs": [
				{"components":[{"name":"totalTokens","type":"uint64"},{"name":"totalEvers","type":"uint64"},{"name":"totalUSD","type":"uint64"},{"name":"totalOrders","type":"uint64"},{"name":"everPrice","type":"uint64"},{"name":"usdPrice","type":"uint64"},{"name":"minOrderAmount","type":"uint64"}],"name":"info","type":"tuple"}
			],
			"outputs": [
			]
		}
	]
}`;

export default {
    abi
}